import { Component, ChangeDetectionStrategy } from "@angular/core";
import { CommonModule } from "@angular/common";

/**
 * Componente spinner per indicare il caricamento
 * Basato sul design di ape-ai-suggestion-modal
 */
@Component({
  selector: "ape-spinner",
  standalone: true,
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: "./ape-spinner.component.html"
})
export class ApeSpinnerComponent {
}

